require("../../../static/js/video/vaneck.youtube.tracking.js");
